var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-system-user-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"detail":_vm.currentData}})}
var staticRenderFns = []

export { render, staticRenderFns }